import React from 'react';
import { Router, Location } from '@reach/router';
import styled from 'styled-components';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

import Header from './components/header';
import Projects from './components/projects';
import ProjectDetails from './components/project-details';
import './index.css';
import FourOhFour from './components/FourOhFour';

const PROJECTS_DATA = '/projects.json';

const Container = styled.div`
  padding: 15px;
  margin: 0 auto;

  @media (min-width: 767px) {
    width: 750px;
  }

  @media (min-width: 992px) {
    width: 970px;
  }

  @media (min-width: 1200px) {
    width: 1170px;
  }
`;

function App() {
  return (
    <Container>
      <Header />
      <FadeTransitionRouter>
        <Projects url={PROJECTS_DATA} path="/" />
        <ProjectDetails url={PROJECTS_DATA} path="project/:name" />
        <FourOhFour default />
      </FadeTransitionRouter>
    </Container>
  );
}

const FadeTransitionRouter = props => (
  <Location>
    {({ location }) => (
      <TransitionGroup className="transition-group">
        <CSSTransition key={location.key} classNames="fade" timeout={300}>
          {/* the only difference between a router animation and
              any other animation is that you have to pass the
              location to the router so the old screen renders
              the "old location" */}
          <Router location={location} className="router">
            {props.children}
          </Router>
        </CSSTransition>
      </TransitionGroup>
    )}
  </Location>
);
export default App;
